<template>
  <div class="flex flex-row justify-evenly flex-wrap gap-2">
    <div class="flex flex-col justify-evenly">
      <LabelField label="CREATE DATE" :display="selectedDraw == null ? '' : format(selectedDraw.created, 'MM/dd/yyyy')"></LabelField>
      <LabelField
        label="APPROVAL DATE"
        :display="selectedDraw == null || selectedDraw.approved == null ? '' : format(selectedDraw.approved, 'MM/dd/yyyy')"
      ></LabelField>
    </div>
    <div class="flex flex-col justify-evenly">
      <LabelField label="TOTAL FUNDS" :display="formatCurrency(summaryData?.funds)"></LabelField>
      <LabelField label="TOTAL BUDGET" :display="formatCurrency(summaryData?.budget)"></LabelField>
      <LabelField
        label="TOTAL VARIANCE"
        :display="formatCurrency(summaryData?.difference)"
        :displayClass="summaryData == null || summaryData.difference < 0 ? 'text-danger-500' : 'text-success-500'"
      ></LabelField>
      <LabelField label="TOTAL RETAINED" :display="formatCurrency(summaryData?.fundsRetained)"></LabelField>
    </div>
    <div class="flex flex-col my-auto">
      <Knob v-model="percentDrawnTween" :valueTemplate="summaryData.percentDrawn + '%'" readonly :size="175" />
      <p class="text-center font-bold -mt-3">Budget Drawn</p>
    </div>
    <div class="flex flex-col my-auto">
      <Knob v-model="percentCompleteTween" :valueTemplate="summaryData.percentComplete + '%'" readonly :size="175" />
      <p class="text-center font-bold -mt-3">Site Complete</p>
    </div>

    <div class="flex flex-col">
      <BalanceMeters v-if="summaryData" :summaryData="summaryData"></BalanceMeters>
    </div>
  </div>
</template>

<script setup lang="ts">
import { format } from "date-fns";
import { formatCurrency } from "@/services/Utility";
import type { ProjectDrawInfo } from "@/types/Projects";
import type { SelectedDraw } from "@/types/Draw";
import gsap from "gsap";

interface Props {
  selectedDraw: SelectedDraw;
  summaryData: ProjectDrawInfo;
}
const props = defineProps<Props>();

const percentDrawnTween = ref(0);
const percentCompleteTween = ref(0);

const updatePercentages = (): void => {
  gsap.to(percentDrawnTween, {
    duration: 0.75,
    value: props.summaryData.percentDrawn > 100 ? 100 : props.summaryData.percentDrawn,
  });
  gsap.to(percentCompleteTween, {
    duration: 0.75,
    value: props.summaryData.percentComplete > 100 ? 100 : props.summaryData.percentComplete,
  });
};

defineExpose({ updatePercentages });

updatePercentages();
</script>
